<template>
  <v-card class="my-4" outlined>
    <v-card-text class="px-0">
      <v-simple-table dense>
        <thead>
          <tr>
            <th colspan="10" class="px-0 text-center text-body-1 font-weight-bold">
              Las inscripciones del programa universidad que cumplen con los requisitos para ser reportados se muestran
              primero, seguidas de las que no cumplen con los requisitos para ser reportados.
            </th>
          </tr>

          <tr>
            <th colspan="10" class="px-0 text-center text-body-2">
              Requisitos para ser reportados: Estado de Inscripción
              <v-chip dark small :color="coloresEstadosInscripcion[1]">Inscrito</v-chip>, Estado de Cartera
              <v-chip dark small :color="coloresEstadosCartera['Exento de deuda']"> Exento de deuda </v-chip>
              o <v-chip dark small :color="coloresEstadosCartera['Vigente']">Vigente</v-chip>, Estado Administrativo
              <v-chip dark small :color="coloresEstadosAdministrativos['Inscrito']"> Inscrito </v-chip>
              y Estado Académico
              <v-chip dark small :color="coloresEstadosAcademicos['En Desarrollo']"> En Desarrollo </v-chip>,
              <v-chip dark small :color="coloresEstadosAcademicos['En Desarrollo - Nivelacion']">
                En Desarrollo - Nivelacion
              </v-chip>
              o
              <v-chip dark small :color="coloresEstadosAcademicos['Concluido Aprobado']"> Concluido Aprobado </v-chip>
            </th>
          </tr>

          <tr>
            <th style="min-width: 30px">#</th>
            <th style="min-width: 120px">ID Inscripción</th>
            <th style="min-width: 220px">Estado Actual</th>
            <th style="min-width: 220px">Estado Cartera</th>
            <th style="min-width: 220px">Estado Administrativo</th>
            <th style="min-width: 220px">Estado Académico</th>
            <th style="min-width: 140px">N° Documento</th>
            <th style="min-width: 300px">Nombre Completo Participante</th>
            <th style="min-width: 120px">ID Programa</th>
            <th style="min-width: 450px">Programa</th>
            <th style="min-width: 200px">Sede</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-if="
              inscripcionesProgramaUniversidadCumplenRequisitos.length === 0 &&
              inscripcionesProgramaUniversidadNoCumplenRequisitos.length === 0
            ">
            <td colspan="11" class="text-center">
              No hay inscripciones para mostrar en el programa de universidad vinculado a este programa.
            </td>
          </tr>

          <tr v-if="inscripcionesProgramaUniversidadCumplenRequisitos.length > 0">
            <td colspan="11" class="px-0">
              <v-alert class="mb-0 text-center" type="success" dense text>
                Inscripciones en el Programa de Universidad que cumplen requisitos para ser reportados
              </v-alert>
            </td>
          </tr>

          <tr
            v-for="(inscripcionProgramaUniversidad, index) in inscripcionesProgramaUniversidadCumplenRequisitos"
            :key="inscripcionProgramaUniversidad.id">
            <td>{{ index + 1 }}</td>
            <td>{{ inscripcionProgramaUniversidad.inscripcion.id }}</td>
            <td class="text-center">
              <v-chip
                :color="coloresEstadosInscripcion[inscripcionProgramaUniversidad.inscripcion.estadoInscripcion]"
                dark
                small>
                {{ estadosInscripcion[inscripcionProgramaUniversidad.inscripcion.estadoInscripcion] }}
              </v-chip>
            </td>
            <td class="text-center">
              <v-chip
                v-if="inscripcionProgramaUniversidad.inscripcion.estadoCartera?.nombre"
                :color="coloresEstadosCartera[inscripcionProgramaUniversidad.inscripcion.estadoCartera.nombre]"
                dark
                small>
                {{ inscripcionProgramaUniversidad.inscripcion.estadoCartera.nombre }}
              </v-chip>

              <span v-else>-</span>
            </td>
            <td class="text-center">
              <v-chip
                v-if="inscripcionProgramaUniversidad.inscripcion.estadoAdministrativo?.nombre"
                :color="
                  coloresEstadosAdministrativos[inscripcionProgramaUniversidad.inscripcion.estadoAdministrativo.nombre]
                "
                dark
                small>
                {{ inscripcionProgramaUniversidad.inscripcion.estadoAdministrativo.nombre }}
              </v-chip>

              <span v-else>-</span>
            </td>
            <td class="text-center">
              <v-chip
                v-if="inscripcionProgramaUniversidad.inscripcion.estadoAcademico?.nombre"
                :color="coloresEstadosAcademicos[inscripcionProgramaUniversidad.inscripcion.estadoAcademico.nombre]"
                dark
                small>
                {{ inscripcionProgramaUniversidad.inscripcion.estadoAcademico.nombre }}
              </v-chip>

              <span v-else>-</span>
            </td>
            <td>{{ inscripcionProgramaUniversidad.inscripcion.estudiante.numeroDocumento }}</td>
            <td>
              {{
                concatenar(
                  inscripcionProgramaUniversidad.inscripcion.estudiante.primerApellido,
                  inscripcionProgramaUniversidad.inscripcion.estudiante.segundoApellido,
                  inscripcionProgramaUniversidad.inscripcion.estudiante.nombres,
                )
              }}
            </td>
            <td>{{ inscripcionProgramaUniversidad.inscripcion.programa.id }}</td>
            <td class="text-truncate">{{ inscripcionProgramaUniversidad.inscripcion.programa.nombreCompuesto }}</td>
            <td class="text-truncate">{{ inscripcionProgramaUniversidad.inscripcion.programa.sede.nombre }}</td>
          </tr>

          <tr v-if="inscripcionesProgramaUniversidadNoCumplenRequisitos.length > 0">
            <td colspan="11" class="px-0">
              <v-alert class="mb-0 text-center" type="error" dense text>
                Inscripciones en el Programa de Universidad que NO cumplen requisitos para ser reportados
              </v-alert>
            </td>
          </tr>

          <tr
            v-for="(inscripcionProgramaUniversidad, index) in inscripcionesProgramaUniversidadNoCumplenRequisitos"
            :key="inscripcionProgramaUniversidad.id">
            <td>
              {{ inscripcionesProgramaUniversidadCumplenRequisitos.length + index + 1 }}
            </td>
            <td>{{ inscripcionProgramaUniversidad.inscripcion.id }}</td>
            <td class="text-center">
              <v-chip
                :color="coloresEstadosInscripcion[inscripcionProgramaUniversidad.inscripcion.estadoInscripcion]"
                dark
                small>
                {{ estadosInscripcion[inscripcionProgramaUniversidad.inscripcion.estadoInscripcion] }}
              </v-chip>
            </td>
            <td class="text-center">
              <v-chip
                v-if="inscripcionProgramaUniversidad.inscripcion.estadoCartera?.nombre"
                :color="coloresEstadosCartera[inscripcionProgramaUniversidad.inscripcion.estadoCartera.nombre]"
                dark
                small>
                {{ inscripcionProgramaUniversidad.inscripcion.estadoCartera.nombre }}
              </v-chip>

              <span v-else>-</span>
            </td>
            <td class="text-center">
              <v-chip
                v-if="inscripcionProgramaUniversidad.inscripcion.estadoAdministrativo?.nombre"
                :color="
                  coloresEstadosAdministrativos[inscripcionProgramaUniversidad.inscripcion.estadoAdministrativo.nombre]
                "
                dark
                small>
                {{ inscripcionProgramaUniversidad.inscripcion.estadoAdministrativo.nombre }}
              </v-chip>

              <span v-else>-</span>
            </td>
            <td class="text-center">
              <v-chip
                v-if="inscripcionProgramaUniversidad.inscripcion.estadoAcademico?.nombre"
                :color="coloresEstadosAcademicos[inscripcionProgramaUniversidad.inscripcion.estadoAcademico.nombre]"
                dark
                small>
                {{ inscripcionProgramaUniversidad.inscripcion.estadoAcademico.nombre }}
              </v-chip>

              <span v-else>-</span>
            </td>
            <td>{{ inscripcionProgramaUniversidad.inscripcion.estudiante.numeroDocumento }}</td>
            <td>
              {{
                concatenar(
                  inscripcionProgramaUniversidad.inscripcion.estudiante.primerApellido,
                  inscripcionProgramaUniversidad.inscripcion.estudiante.segundoApellido,
                  inscripcionProgramaUniversidad.inscripcion.estudiante.nombres,
                )
              }}
            </td>
            <td>{{ inscripcionProgramaUniversidad.inscripcion.programa.id }}</td>
            <td class="text-truncate">{{ inscripcionProgramaUniversidad.inscripcion.programa.nombreCompuesto }}</td>
            <td class="text-truncate">{{ inscripcionProgramaUniversidad.inscripcion.programa.sede.nombre }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  COLORES_ESTADOS_ACADEMICOS,
  COLORES_ESTADOS_ADMINISTRATIVOS,
  COLORES_ESTADOS_CARTERA,
  COLORES_ESTADOS_INSCRIPCION,
  ESTADOS_INSCRIPCION,
} from '../utils/constantes';
export default {
  name: 'TablaInscripcionesProgramaUniversidad',
  props: {
    inscripcionesProgramaUniversidadCumplenRequisitos: {
      type: Array,
      required: true,
    },
    inscripcionesProgramaUniversidadNoCumplenRequisitos: {
      type: Array,
      required: true,
    },
  },
  computed: {},
  data() {
    return {
      estadosInscripcion: ESTADOS_INSCRIPCION,
      coloresEstadosInscripcion: COLORES_ESTADOS_INSCRIPCION,
      coloresEstadosCartera: COLORES_ESTADOS_CARTERA,
      coloresEstadosAdministrativos: COLORES_ESTADOS_ADMINISTRATIVOS,
      coloresEstadosAcademicos: COLORES_ESTADOS_ACADEMICOS,
    };
  },
  methods: {
    concatenar(...args) {
      return args.filter((arg) => arg).join(' ');
    },
  },
};
</script>